import React from 'react';
import { Card, CardContent } from './ui/card';
import { ArrowRight } from 'lucide-react';

const ServiceCard = ({ service, index }) => {
  return (
    <Card className="db-orb-card bg-gradient-to-br from-white/5 to-white/10 border-white/10 hover:border-orange-500/50 transition-all duration-300 hover:scale-[1.02] hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(249,115,22,0.15)] group overflow-hidden">
      <div className="relative h-[230px] overflow-hidden">
        <img 
          src={service.image} 
          alt={`${service.title} - ${service.description.substring(0, 100)}`}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          loading="lazy"
          width="600"
          height="400"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
        <div className="absolute top-4 left-4 bg-gradient-to-r from-orange-500 to-amber-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
          {service.badge}
        </div>
      </div>
      <CardContent className="p-6">
        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-orange-500 transition-colors">
          {service.title}
        </h3>
        <p className="text-neutral-400 mb-4">
          {service.description}
        </p>
        <ul className="space-y-2">
          {service.features.map((feature, idx) => (
            <li key={idx} className="text-neutral-300 flex items-start">
              <ArrowRight className="h-4 w-4 text-orange-500 mr-2 mt-0.5 flex-shrink-0" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
